import React, { useCallback, useState } from 'react';
import { ReactMic } from 'react-mic';
import { useParams } from 'react-router';
import { Alert, Icon, InputGroup } from 'rsuite';
import { storage } from '../../../misc/firebase';

const AudioBtnModal = ({ afterUpload }) => {
  const [isRecording, setRecording] = useState(false);
  const [isUploading, setUploading] = useState(false);
  const { chatId } = useParams();

  const onClick = useCallback(() => {
    setRecording(p => !p);
  }, []);

  const onUpload = useCallback(
    async data => {
      try {
        const snap = await storage
          .ref(`/chat/${chatId}`)
          .child(`audio_${Date.now()}.mp3`)
          .put(data.blob, {
            cacheControl: `public, max-age=${3600 * 24 * 3}`,
          });

        const file = {
          contentType: snap.metadata.contentType,
          name: snap.metadata.name,
          url: await snap.ref.getDownloadURL(),
        };
        setUploading(false);
        afterUpload([file]);
      } catch (err) {
        setUploading(false);
        Alert.error(err.message);
      }
    },
    [chatId, afterUpload]
  );
  return (
    <InputGroup.Button
      onClick={onClick}
      disabled={isUploading}
      className={isRecording ? 'animate-blink' : ''}
    >
      <Icon icon="microphone" />

      <ReactMic
        record={isRecording}
        className="d-none"
        onStop={onUpload}
        mimeType="audio/mp3"
      />
    </InputGroup.Button>
  );
};

export default AudioBtnModal;
